import { resolveLocale } from '@/localization';

export const meterFormat = {
  style: 'unit',
  unit: 'meter',
  unitDisplay: 'short',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
} as const satisfies Intl.NumberFormatOptions;

export const degreeFormat = {
  style: 'unit',
  unit: 'degree',
  unitDisplay: 'narrow',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
} as const satisfies Intl.NumberFormatOptions;

/** Unit symbol for a measurement format, e.g. "m" or "°". */
export const measurementUnitSymbol = ({
  language,
  options,
}: {
  language: string;
  options: Intl.NumberFormatOptions;
}): string =>
  new Intl.NumberFormat(resolveLocale(language), options)
    .formatToParts(0)
    .find(part => part.type === 'unit')?.value ?? '';
